import { render, staticRenderFns } from "./BadgeOptions.vue?vue&type=template&id=69fa78b7"
import script from "./BadgeOptions.vue?vue&type=script&lang=ts"
export * from "./BadgeOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports